import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { staticData } from "./static.data"
import StepContentWrapper from "./../stepContentWrapper"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

class Motivation extends Component {
  constructor() {
    super();

    this.state = {
      currentStepOpened: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.motivation) && !this.state.motivation)
      this.setState({ currentStepOpened: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { currentStepOpened } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.motivation,
      isOpen: currentStepOpened,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (currentStepOpened && !has(data, ["motivation"]))
      onSetStepData("motivation")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      currentStepOpened: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { currentStepOpened } = this.state
    const params = {
      className: "wrapperCurrentActivity",
      currentIndex: currentIndex,
      stepIndex: steps.motivation,
    }

    return currentStepOpened ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          {/* <FirstTitle>{locales[window.userLang].activity_ask}</FirstTitle> */}
          <FirstTitle>{locales[window.userLang].motivation_step_title}</FirstTitle>

          {
            Object.keys(staticData).map((key, index) => {
              // console.log(staticData[key])
              // console.log(staticData)
              return (
                // ''
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["motivation", "value"], null) === staticData[key].value}
                  onClick={() => {
                    if (get(data, ["motivation", "value"], null) !== staticData[key].value) {
                      onUpdateStepData.bind(this, "motivation", "value", staticData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={staticData[key].icon}
                >
                  {staticData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(Motivation);